import { render, staticRenderFns } from "./FacilityEdit.vue?vue&type=template&id=528328b5"
import script from "./FacilityEdit.vue?vue&type=script&lang=js"
export * from "./FacilityEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports